import { StepAction } from './stepAction';
import type { ExtractTextStep } from 'clickim/src/common/models/extractTextStep';

export class ExtractTextStepAction extends StepAction<ExtractTextStep> {
    async performAction() {
        const paramName = this.step.extractTextParamName!;

        const extractedText = await this.stepActionUtils.extractTargetText(this.getTarget());
        this.context.data.exports ||= {};
        this.context.data.exports[paramName] = extractedText;
        return {
            success: true,
            data: this.context.data,
        };
    }
}
